import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

const MenuWrapper = styled.div`
  position: fixed;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 3px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 1000;
  overflow: hidden;
`;

const MenuItem = styled.div`
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${({ theme }) => theme.themeColors.lowContrastBorder};
  }

  &.danger {
    color: #dc2626;

    &:hover {
      background: rgba(220, 38, 38, 0.1);
    }
  }
`;

const MenuDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.themeColors.border};
  margin: 0;
`;

export const RowColumnMenu = ({ type, index, position, onClose, onDelete, onInsertBefore, onInsertAfter }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleDelete = () => {
    onDelete(index);
    onClose();
  };

  const handleInsertBefore = () => {
    onInsertBefore(index);
    onClose();
  };

  const handleInsertAfter = () => {
    onInsertAfter(index);
    onClose();
  };

  const label = type === 'row' ? `Row ${index + 1}` : `Column ${String.fromCharCode(65 + index)}`;
  const insertBeforeLabel = type === 'row' ? 'Insert row above' : 'Insert column to the left';
  const insertAfterLabel = type === 'row' ? 'Insert row below' : 'Insert column to the right';

  return (
    <>
      <MenuOverlay onClick={onClose} />
      <MenuWrapper
        ref={menuRef}
        style={{
          top: position.top,
          left: position.left,
        }}
      >
        <MenuItem onClick={handleInsertBefore}>
          <Body5>{insertBeforeLabel}</Body5>
        </MenuItem>
        <MenuItem onClick={handleInsertAfter}>
          <Body5>{insertAfterLabel}</Body5>
        </MenuItem>
        <MenuDivider />
        <MenuItem onClick={handleDelete} className="danger">
          <Body5>Delete {label}</Body5>
        </MenuItem>
      </MenuWrapper>
    </>
  );
};
